import {
  AspectRatio,
  Badge,
  Body,
  Box,
  Heading,
  Image,
  Link,
} from '@hover/blueprint';
import { navigate } from 'gatsby';
import React, { FC } from 'react';
import { BLOG_CATEGORIES } from '../../../constants';
import { ICBlogPost } from '../../../interfaces/ICBlogPost';
import { dateToFormat } from '../../../utils';

interface Props {
  post: ICBlogPost;
}

const BlogCard: FC<Props> = ({ post }) => {
  const postCategoryData = BLOG_CATEGORIES.find(
    item => item.value === post.categories[0],
  );
  return (
    <Box
      flexDirection="column"
      key={post.title}
      cursor="pointer"
      onClick={() => navigate(`/blog/${post.slug}/`)}
    >
      <Link href={`/blog/${post.slug}/`}>
        <AspectRatio ratio={2}>
          <Image
            loading="lazy"
            src={post.heroImage.url}
            alt={post.description}
            objectFit="cover"
          />
        </AspectRatio>
      </Link>
      <Box justifyContent="space-between" w="100%" py={500}>
        <Box alignItems="center">
          {postCategoryData && (
            <Badge
              colorScheme={postCategoryData.color}
              variant="brand"
              textTransform="uppercase"
            >
              {postCategoryData.value}
            </Badge>
          )}
        </Box>
      </Box>
      <Heading
        size={300}
        pb={400}
        _hover={{ textDecoration: 'none' }}
        marginBottom={0}
        as="h3"
      >
        {post.title}
      </Heading>
      <Body size={300} marginTop="auto" fontWeight={300}>
        {dateToFormat(post.publishDate)}
      </Body>
    </Box>
  );
};

export default BlogCard;
